import { API_BASE_URL } from "../../constants/index";
import HttpInterface from "../../helpers/HttpInterface";

export class AddressBookService {
  private httpProxy: HttpInterface;

  /**
   * Creates an instance of ShipmentsService.
   * Initializes an HTTP interface to perform API requests.
   */
  constructor() {
    this.httpProxy = new HttpInterface();
  }

  get(id: string): Promise<any> {
    const requestOptions = {
      method: "GET",
    };

    return this.httpProxy.fetch(
      `${API_BASE_URL}/shipment-service/address-book/${id}`,
      requestOptions
    );
  }
}
